import { render, staticRenderFns } from "./AudanetSubmitItemsModal.vue?vue&type=template&id=31a2c4af&scoped=true"
import script from "./AudanetSubmitItemsModal.vue?vue&type=script&lang=js"
export * from "./AudanetSubmitItemsModal.vue?vue&type=script&lang=js"
import style0 from "./AudanetSubmitItemsModal.vue?vue&type=style&index=0&id=31a2c4af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2c4af",
  null
  
)

export default component.exports